import shortid from 'shortid'
// 生成的id不能有中划线-,因为青瓷默认有中划线的命名文件为多语言图片,会执行相关预加载逻辑引起报错
shortid.characters(
  '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$@'
)
export default function generateId() {
  return shortid.generate()
}
